import { createFileRoute } from "@tanstack/react-router";
import { AuthScreen } from "@/components/auth-screen";

export const Route = createFileRoute("/auth")({
  head: () => ({
    meta: [
      { title: "Entrar · Beit Tefilah Rechovot" },
      {
        name: "description",
        content: "Acesse a área de membros da congregação Beit Tefilah Rechovot.",
      },
      { name: "robots", content: "noindex" },
      { property: "og:type", content: "website" },
      { property: "og:title", content: "Entrar · Área de Ensinos Beit Tefilah Rechovot" },
      {
        property: "og:description",
        content:
          "Login exclusivo para membros: acesse o acervo de ensinos por Parashá, data e festividade.",
      },
      { name: "twitter:title", content: "Entrar · Área de Ensinos Beit Tefilah Rechovot" },
      {
        name: "twitter:description",
        content:
          "Login exclusivo para membros: acesse o acervo de ensinos por Parashá, data e festividade.",
      },
    ],
  }),
  component: AuthScreen,
});
